import { trackerIds } from '@zg-rentals/particles-js-analytics';
import { setComscore } from 'app/shared/flux/actions/AnalyticsActions';
import MultiAnalyticsModule from 'app/shared/utils/analytics';

function setupAnalytics(dispatch) {
    const ma = MultiAnalyticsModule.getInstance().getMa();
    ma.setCustomDimensions(
        {
            name: 'dimension25',
            value: 'mobile'
        },
        [trackerIds.ids.ua.zrm]
    );
    ma.setCustomDimensions(
        {
            name: 'dimension23',
            value: 'postingPathAdmin'
        },
        [trackerIds.ids.ua.zrm]
    );

    ma.trackPageView(
        {
            path: window.location.pathname
        },
        null,
        () => dispatch(setComscore())
    );
}

export default setupAnalytics;
